/*
 * Copyright (c) 2023 CalAmp Corp. All Rights Reserved
 */
import {ColumnState} from 'ag-grid-community';
import produce from 'immer';
import {
  getGridColumnState,
  onSetGridColumns,
  onUpdateGridColumns
} from '@ion/applications/src/store/helpers';
import {PageState} from '@ion/applications/src/types/pages';
import {ServiceError} from '@ion/core/src/types/services';
import {PageInitializeAction} from '@/types/redux';

// Define the page state
export interface VisionState extends PageState {
  grid: {
    columnState: ColumnState[];
    preferedColumnState: ColumnState[];
    hasUpdate: boolean;
  };
  vision: {
    tab: number,
    error: ServiceError;
    loading: boolean;
  };
  video: {
    isDiscardEvent: boolean;
    discardVideoId: string;
  };
  videoSearch: string;
}

export const NAME = 'vision';

export const INITIALIZE_VISION       = 'INITIALIZE_VISION';
export const SET_GRID_COLUMNS        = 'SET_VISION_GRID_COLUMNS';
export const UPDATE_GRID_COLUMNS     = 'UPDATE_VISION_GRID_COLUMNS';
export const VIEW_VISION_EVENTS      = 'VIEW_VISION_EVENTS';
export const SET_VIDEO_SEARCH_VALUE  = 'SET_VIDEO_SEARCH_VALUE';
export const SET_VIDEO_DISCARD_EVENT = 'SET_VIDEO_DISCARD_EVENT';
export const SET_VISION_TAB_VALUE    = 'SET_VISION_TAB_VALUE';
// Actions
export const initializeVision = (): PageInitializeAction => {
  return {type: INITIALIZE_VISION};
};

export const setVideoSearch = (value: string) => ({
  type : SET_VIDEO_SEARCH_VALUE, value
});

export const setVideoDiscard = (value: any, flag: boolean) => ({
  type : SET_VIDEO_DISCARD_EVENT, value, flag
});

export const setVisionTab = (value: number) => ({
  type : SET_VISION_TAB_VALUE, value
});

export const viewVisionEvents = (event: any) => ({type: VIEW_VISION_EVENTS, event});

export const initialState: VisionState = {
  isInitialized : false,
  grid          : {
    columnState         : null,
    preferedColumnState : null,
    hasUpdate           : false
  },
  vision : {
    tab     : 0,
    error   : null,
    loading : false
  },
  video : {
    isDiscardEvent : false,
    discardVideoId : null
  },
  videoSearch : null
};

// Reducers
const reducers = {
  [INITIALIZE_VISION] : (draft: VisionState) => {
    draft.isInitialized            = true;
    const preference               = getGridColumnState(NAME, true);
    draft.grid.columnState         = preference;
    draft.grid.preferedColumnState = preference;
  },
  [SET_GRID_COLUMNS] : ({grid, vision}: VisionState, {columnState}) => {
    onSetGridColumns({
      grid,
      isLoading  : vision.loading,
      preference : NAME
    }, columnState);
  },
  [UPDATE_GRID_COLUMNS] : ({grid}: VisionState, {columnState}) => {
    onUpdateGridColumns({grid, preference: NAME}, columnState);
  },
  [SET_VIDEO_SEARCH_VALUE] : (draft: VisionState, {value}) => {
    draft.videoSearch = value;
  },
  [SET_VIDEO_DISCARD_EVENT] : (draft: VisionState, {value, flag}: any) => {
    draft.video.isDiscardEvent = flag;
    draft.video.discardVideoId = value;
  },
  [SET_VISION_TAB_VALUE] : (draft: VisionState, {value}) => {
    draft.vision.tab = value;
  }
};

export default produce((draft: VisionState = initialState, action) => {
  reducers?.[action.type]?.(draft, action);
  return draft;
});
